"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StackedNav = exports.StackedNavItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _reactDomInteractions = require("@floating-ui/react-dom-interactions");

var _styles = require("./shared/styles");

var _LinkWithWrapper = require("./LinkWithWrapper");

var _excluded = ["icon", "children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var StackedNavLabel = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ei9otp23"
} : {
  target: "ei9otp23",
  label: "StackedNavLabel"
})(_styles.subheading.small, ";color:", _styles.color.dark, ";text-transform:uppercase;margin-bottom:16px;");
var GroupContainer = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ei9otp22"
} : {
  target: "ei9otp22",
  label: "GroupContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1s01xan",
  styles: "margin-bottom:24px;&:last-of-type{margin-bottom:0;}"
} : {
  name: "1s01xan",
  styles: "margin-bottom:24px;&:last-of-type{margin-bottom:0;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var StackedNavItemLabel = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ei9otp21"
} : {
  target: "ei9otp21",
  label: "StackedNavItemLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "16qjul5",
  styles: "white-space:nowrap;flex:1;text-overflow:ellipsis;overflow:hidden;min-width:0"
} : {
  name: "16qjul5",
  styles: "white-space:nowrap;flex:1;text-overflow:ellipsis;overflow:hidden;min-width:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var PureStackedNavItem = ( /*#__PURE__*/0, _theming.styled)(_LinkWithWrapper.LinkWithWrapper, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'active';
  },
  target: "ei9otp20"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'active';
  },
  target: "ei9otp20",
  label: "PureStackedNavItem"
})("display:flex;align-items:center;font-weight:", _styles.typography.weight.regular, ";font-size:", _styles.typography.size.s2, "px;line-height:20px;text-decoration:none;color:", _styles.color.darkest, ";transition:color 150ms ease-out;outline:0;svg,img{flex:none;width:14px;height:14px;margin-right:10px;}margin-bottom:12px;&:last-of-type{margin-bottom:0;}&:hover,&:focus,&:active{color:", _styles.color.secondary, ";}&:focus-visible{outline:2px solid ", _styles.color.secondary, ";outline-offset:4px;border-radius:2px;}", function (props) {
  return props.active && /*#__PURE__*/(0, _theming.css)("outline:2px solid ", _styles.color.secondary, ";outline-offset:4px;border-radius:2px;" + (process.env.NODE_ENV === "production" ? "" : ";label:PureStackedNavItem;"));
}, ";");
var StackedNavItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var icon = _ref.icon,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(PureStackedNavItem, (0, _extends2["default"])({}, props, {
    ref: ref,
    role: "menuitem"
  }), icon, /*#__PURE__*/_react["default"].createElement(StackedNavItemLabel, null, children));
});
exports.StackedNavItem = StackedNavItem;
StackedNavItem.displayName = 'StackedNavItem';

var StackedNav = function StackedNav(_ref2) {
  var label = _ref2.label,
      children = _ref2.children;
  var id = (0, _reactDomInteractions.useId)();
  return /*#__PURE__*/_react["default"].createElement(GroupContainer, {
    role: "group",
    "aria-label": "StackedNav-label-".concat(id)
  }, /*#__PURE__*/_react["default"].createElement(StackedNavLabel, {
    id: "StackedNav-label-".concat(id)
  }, label), children);
};

exports.StackedNav = StackedNav;